import Glider from "glider-js";
import "glider-js/glider.min.css";

export function carousels() {
  const wrappers: NodeListOf<HTMLElement> = document.querySelectorAll(
    ".carousel-component__slides"
  );
  wrappers.forEach((el) => {
    const slidesToShow = parseFloat(el.dataset.slidesToShow || "3");
    const carouselN = parseInt(el.dataset.carouselN || "1", 10);
    new Glider(el as HTMLElement, {
      slidesToShow: 1.3,
      slidesToScroll: 1,
      dots: ".dots_" + carouselN,
      arrows: {
        prev: ".glider-prev_" + carouselN,
        next: ".glider-next_" + carouselN,
      },
      // draggable: true,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: slidesToShow * 1.5,
            slidesToScroll: 1,
            dots: ".dots_" + carouselN,
            arrows: {
              prev: ".glider-prev_" + carouselN,
              next: ".glider-next_" + carouselN,
            },
          },
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow,
            slidesToScroll: 1,
            dots: ".dots_" + carouselN,
            arrows: {
              prev: ".glider-prev_" + carouselN,
              next: ".glider-next_" + carouselN,
            },
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1.8,
            slidesToScroll: 1,
            dots: ".dots_" + carouselN,
            arrows: {
              prev: ".glider-prev_" + carouselN,
              next: ".glider-next_" + carouselN,
            },
          },
        },
      ],
    });
  });

  addEmbedFunctionality();
}

function addEmbedFunctionality() {
  // Create holder for embed elements...
  const embedHolder = document.createElement("div");
  embedHolder.classList.add("embed-holder");
  document.body.appendChild(embedHolder);

  document
    .querySelectorAll(".carousel-component__slide--embed")
    .forEach((el) => {
      const img = el.querySelector("img");
      const iframe = el.querySelector(".carousel-component__embed-code");
      img?.addEventListener("click", () => {
        if (iframe) {
          iframe.classList.toggle("carousel-component__embed-code--active");
          embedHolder.appendChild(iframe);
        }
      });
      iframe?.addEventListener("click", () => {
        embedHolder.removeChild(iframe);
      });
    });
}
